import type { KeycardTemplate } from 'cleverev-types'
import { api } from './api'


export type Keycard = {
  id: string
  hardwareId: string
  friendlyId: string
  createdAt: string
  updatedAt: string
}

class KeycardAPI {

  public async listKeycards(organizationId: string) {
    const result = await api.get<{ keycardTemplates: KeycardTemplate[]; totalCount: number }>(`/organizations/${organizationId}/keycard-templates?take=9999`) // TODO: implement pagination

    return result.data
  }

  public async get(keycardId: string) {
    const result = await api.get<{ keycardTemplate: KeycardTemplate }>(`/keycard-templates/${keycardId}`)

    return result.data.keycardTemplate
  }

  public async update(id: string, partialKeycard: Partial<KeycardTemplate>) {
    const result = await api.post<{ keycardTemplate: KeycardTemplate }>(
      `/charger-setups/${id}`,
      partialKeycard
    )

    return result.data.keycardTemplate
  }

  public async create(newKeycard: Partial<KeycardTemplate>) {
    const result = await api.post<{ keycardTemplate: KeycardTemplate }>(
      '/keycard-templates',
      { keycardTemplate: newKeycard }
    )

    return result.data.keycardTemplate
  }

  public async delete(id: string) {
    await api.delete(`/keycard-templates/${id}`)

    return null
  }

}

export const keycardAPI = new KeycardAPI()
